import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import ProfileInfo from '../../components/profilemng/ProfileInfo';
import ProfileTemplate from '../../components/profilemng/ProfileTemplate';
import ApprovalListContainer from './apprroval/ApprovalListContainer';



const ProfileContainer = () => {
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  const { user } = useSelector(({ auth }) => ({
    user: auth.user, //user정보
  }));

  useEffect(() => {
    if (user) {
      let title = {
        name: "["+user.usrNo+"] "+user.usrNm + ' ' + user.gradeNm,
        no: user.usrNo,
      };
      setTitleData(title);
    }
  }, [user]);

  const handleGoBack = () => {
    navigate('/profile');
  };

  const handleEdit = () => {
    navigate(`/profile/edit`);
  };

  return (
    <ProfileTemplate user={user}>
      <TitleBox
        edit
        handleGoBack={handleGoBack}
        menuName="사용자관리/프로필관리/상세보기"
        menuLink="/profile"
        icon="user"
        titleData={titleData}
        handleEdit={handleEdit}
      />
      <DetailTemplate title="기본정보">
        <ProfileInfo employee={user} />
      </DetailTemplate>
      <DetailTemplate title="결재선 관리">
        <ApprovalListContainer />
      </DetailTemplate>
    </ProfileTemplate>
  );
};

export default ProfileContainer;
